import { useState } from "react";

// Renders the Jesus Said in Red logo from /public/logos/.
// Falls back to a brand-styled wordmark if the image hasn't been uploaded.
export function JsirLogo({ className = "h-8" }: { className?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className={`inline-flex items-center gap-1.5 font-bold italic text-brand leading-none tracking-tight ${className}`}>
        <span className="text-2xl leading-none">,,</span>
        <span className="uppercase text-sm">Jesus Said in Red</span>
      </span>
    );
  }
  return (
    <img
      src="/logos/jesus-said-in-red.png"
      alt="Jesus Said in Red"
      className={className}
      onError={() => setFailed(true)}
    />
  );
}

export function GlobalHarvestLogo({ className = "h-5" }: { className?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <span className="text-xs font-medium text-[#3D8FAC]">The Global Harvest</span>;
  return (
    <img
      src="/logos/global-harvest.png"
      alt="The Global Harvest"
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
